module.exports = __webpack_public_path__ + "img/banner.938f67c7.jpg";